import axios from 'axios';
import { authconfig } from '../shared/utils/common';
import config from '../../config';
import { getCookie } from '../shared/utils/format.helpers';
import { mockDataStores, mockDataBrands } from '../mockData/otterMockData';

const wrapperURL = process.env.OTTER_SERVICE_API;

export async function loginUsingCode(code) {
	//to login after otter session
  let configs = authconfig(config.env, 'merchant-auth');
  return await axios
    .post(
      `${wrapperURL}/v1/auth/token?scope=organization.read organization.service_integration&grant_type=authorization_code&code=${code}&redirect_uri=${process.env.OTTER_REDIRECT_URL}`,
      {},
      {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'x-api-key': configs.headers['x-api-key'], 'authorization': `Bearer ${getCookie('_appToken')}` },
      }
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
}

export async function getAllOrganization(action) {
  let configs = authconfig(config.env, 'merchant-auth');
  const headerconfig = {
    headers: {
      'Authorization': `Bearer ${action.access_token}`,
      'x-api-key': configs.headers['x-api-key'],
    },
  };
  return await axios
    .get(`${wrapperURL}/v1/organization`, { timeout: 10000, ...headerconfig })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
}

export async function getBrandList(action) {
  let configs = authconfig(config.env, 'merchant-auth');
  const headerconfig = {
    headers: {
      'Authorization': `Bearer ${action.access_token}`,
      'x-api-key': configs.headers['x-api-key'],
    },
  };
  return await axios
    .get(`${wrapperURL}/v1/organization/brands?limit=1000`, { timeout: 10000, ...headerconfig })
    .then((res) => {
    	return res;
		//return mockDataBrands;
    
      })
    .catch((err) => {
      return err;
    });
}

export async function getBrandDetails(code, brandID) {
  //can be removed
  let configs = authconfig(config.env, 'merchant-auth');
  const headerconfig = {
    headers: {
      'Authorization': `Bearer ${code}`,
      'x-api-key': configs.headers['x-api-key'],
    },
  };
  return await axios
    .get(`${wrapperURL}/v1/organization/brands/${brandID}`, { timeout: 10000, ...headerconfig })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
}

export async function getStoresFromBrands(action) {
  let configs = authconfig(config.env, 'merchant-auth');
  const headerconfig = {
    headers: {
      'Authorization': `Bearer ${action.access_token}`,
      'x-api-key': configs.headers['x-api-key'],
    },
  };
  return await axios
    .get(`${wrapperURL}/v1/organization/brands/${action?.payload?.data?.id}/stores?limit=1000`, { timeout: 10000, ...headerconfig })
    .then((res) => {
      	return { ...res, brandID: action?.payload?.data?.id };
    	//return mockDataStores 
    });
}

export async function getStoresDetailsFromBrands(action) {
  // console.log('PAY ',res)
  let configs = authconfig(config.env, 'merchant-auth');
  let { brandID, storeID } = action.payload.data;
  // let code, brandID, storeID = '';
  const headerconfig = {
    headers: {
      'Authorization': `Bearer ${action.access_token}`,
      'x-api-key': configs.headers['x-api-key'],
    },
  };
  return await axios
    .get(`${wrapperURL}/v1/organization/brands/${brandID}/stores/${storeID}`, { timeout: 10000, ...headerconfig })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
}

export async function postStoreConnect(action) {
  //activate a store
  let { integrationToken, brandID, storeID, accessTokenValue } = action.payload.data;
  let headerconfig = authconfig(config.env, 'merchant-auth');
  // console.log('POST ', accessTokenValue, 'INEGRATION TOKEN ',integrationToken,'BRAND ID',brandID,'STORE ID', storeID)
  return await axios
    .post(
      `${wrapperURL}/v1/organization/brands/${brandID}/stores/${storeID}/connection?storeId=${storeID}`,
      {},
      {
        headers: {
          'Authorization': `Bearer ${integrationToken}`,
          'Content-Type': 'application/x-www-form-urlencoded',
          'user_authentication': accessTokenValue,
          'x-api-key': headerconfig.headers['x-api-key'],
        },
      }
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
}

export async function getStoreConnectServiceCall(action) {
  //status of each store(do not remove)
  // console.log('PAY ',res)
  let { integrationToken, brandID, storeID } = action.payload.data;
  let configs = authconfig(config.env, 'merchant-auth');
  // console.log('GET CONNECTION ', integrationToken,'BRAND ID',brandID,'STORE ID', storeID)
  // let code, brandID, storeID = '';
  const headerconfig = {
    headers: {
      'Authorization': `Bearer ${integrationToken}`,
      'x-api-key': configs.headers['x-api-key'],
    },
  };
  return await axios
    .get(`${wrapperURL}/v1/organization/brands/${brandID}/stores/${storeID}/connection?storeId=${storeID}`, { timeout: 10000, ...headerconfig })
    .then((res) => {
      return { ...res, storeID: storeID };
    })
    .catch((err) => {
      return { ...err, storeID: storeID };
    });
}

export async function deleteStoreConnect(action) {
  //deactivate a store(do not remove)
  // console.log('PAY ',res)
  let { integrationToken, brandID, storeID, accessTokenValue } = action.payload.data;
  let configs = authconfig(config.env, 'merchant-auth');
  // console.log('DELETE CONNECTION ', accessTokenValue, 'INEGRATION TOKEN ',integrationToken,'BRAND ID',brandID,'STORE ID', storeID)
  // let code, brandID, storeID = '';
  const headerconfig = {
    headers: {
      'Authorization': `Bearer ${integrationToken}`,
      'user_authentication': accessTokenValue,
      'x-api-key': configs.headers['x-api-key'],
    },
  };
  return await axios
    .delete(`${wrapperURL}/v1/organization/brands/${brandID}/stores/${storeID}/connection`, { timeout: 10000, ...headerconfig })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
}
